import script from "./ArchiveQuery.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveQuery.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveQuery.vue?vue&type=style&index=0&id=18f50dfa&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18f50dfa"]])

export default __exports__